import { Reducer } from "redux";

import { AttachLetterResponse } from "../models/Api/Document";
import { AttachLetterDispatchTypes } from "../models/DispatchTypes/Document";
import { AttachLetterActionDispatchTypes } from "../constants/Document";

const initialState: AttachLetterResponse = {
  loading: false,
  response: false,
  error: null,
};

const SaveAttachLetter: Reducer<
  AttachLetterResponse,
  AttachLetterDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case AttachLetterActionDispatchTypes.POST_ATTACH_LETTER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case AttachLetterActionDispatchTypes.POST_ATTACH_LETTER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: {},
      };
    }
    case AttachLetterActionDispatchTypes.POST_ATTACH_LETTER_ERROR: {
      return {
        ...state,
        error: action.response,
        loading: false,
      };
    }
    case AttachLetterActionDispatchTypes.POST_ATTACH_LETTER_RESET: {
      return initialState;
    }
  }
  return state;
};

export default SaveAttachLetter;
